import { ref, isRef, Ref } from 'vue'
import { useCommand } from '@cqrs/vue-composables-cqrs'
import * as c from './commands-core'

export function useCreateCostSubtotalCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }

			return new c.CreateCostSubtotalCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value)
		})
	}

	return {
		...result,
		authorizedCreateCostSubtotalCommandV1: result.authorized,
		createCostSubtotalCommandV1: result.command,
		completedCreateCostSubtotalCommandV1: result.completed,
		errorCreateCostSubtotalCommandV1: result.error,
		invokeCreateCostSubtotalCommandV1: result.invoke,
		invokingCreateCostSubtotalCommandV1: result.invoking,
		succeedCreateCostSubtotalCommandV1: result.succeed,
		validationErrorsCreateCostSubtotalCommandV1: result.validationErrors,
		onSucceedCreateCostSubtotalCommandV1: result.onSucceed,
	}
}

export function useCreateExpenseAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	classification?: any | Ref<any> | (() => any), 
	subtotalId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _classification = isRef<any>(classification) ? classification : ref<any>((typeof classification === 'function') ? classification() : classification)
	const _subtotalId = isRef<string>(subtotalId) ? subtotalId : ref<string>((typeof subtotalId === 'function') ? subtotalId() : subtotalId)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		classification: _classification,
		subtotalId: _subtotalId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof classification === 'function') { _classification.value = classification() }
			if (typeof subtotalId === 'function') { _subtotalId.value = subtotalId() }

			return new c.CreateExpenseAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _classification.value, _subtotalId.value)
		})
	}

	return {
		...result,
		authorizedCreateExpenseAccountCommandV1: result.authorized,
		createExpenseAccountCommandV1: result.command,
		completedCreateExpenseAccountCommandV1: result.completed,
		errorCreateExpenseAccountCommandV1: result.error,
		invokeCreateExpenseAccountCommandV1: result.invoke,
		invokingCreateExpenseAccountCommandV1: result.invoking,
		succeedCreateExpenseAccountCommandV1: result.succeed,
		validationErrorsCreateExpenseAccountCommandV1: result.validationErrors,
		onSucceedCreateExpenseAccountCommandV1: result.onSucceed,
	}
}

export function useDeleteCostSubtotalCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteCostSubtotalCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteCostSubtotalCommandV1: result.authorized,
		deleteCostSubtotalCommandV1: result.command,
		completedDeleteCostSubtotalCommandV1: result.completed,
		errorDeleteCostSubtotalCommandV1: result.error,
		invokeDeleteCostSubtotalCommandV1: result.invoke,
		invokingDeleteCostSubtotalCommandV1: result.invoking,
		succeedDeleteCostSubtotalCommandV1: result.succeed,
		validationErrorsDeleteCostSubtotalCommandV1: result.validationErrors,
		onSucceedDeleteCostSubtotalCommandV1: result.onSucceed,
	}
}

export function useDeleteExpenseAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }

			return new c.DeleteExpenseAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value)
		})
	}

	return {
		...result,
		authorizedDeleteExpenseAccountCommandV1: result.authorized,
		deleteExpenseAccountCommandV1: result.command,
		completedDeleteExpenseAccountCommandV1: result.completed,
		errorDeleteExpenseAccountCommandV1: result.error,
		invokeDeleteExpenseAccountCommandV1: result.invoke,
		invokingDeleteExpenseAccountCommandV1: result.invoking,
		succeedDeleteExpenseAccountCommandV1: result.succeed,
		validationErrorsDeleteExpenseAccountCommandV1: result.validationErrors,
		onSucceedDeleteExpenseAccountCommandV1: result.onSucceed,
	}
}

export function useRenameCostSubtotalCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }

			return new c.RenameCostSubtotalCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value)
		})
	}

	return {
		...result,
		authorizedRenameCostSubtotalCommandV1: result.authorized,
		renameCostSubtotalCommandV1: result.command,
		completedRenameCostSubtotalCommandV1: result.completed,
		errorRenameCostSubtotalCommandV1: result.error,
		invokeRenameCostSubtotalCommandV1: result.invoke,
		invokingRenameCostSubtotalCommandV1: result.invoking,
		succeedRenameCostSubtotalCommandV1: result.succeed,
		validationErrorsRenameCostSubtotalCommandV1: result.validationErrors,
		onSucceedRenameCostSubtotalCommandV1: result.onSucceed,
	}
}

export function useUpdateCostAccountClassificationCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	classification?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _classification = isRef<any>(classification) ? classification : ref<any>((typeof classification === 'function') ? classification() : classification)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		classification: _classification,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof classification === 'function') { _classification.value = classification() }

			return new c.UpdateCostAccountClassificationCommandV1(_workspaceId.value, _strategyId.value, _id.value, _classification.value)
		})
	}

	return {
		...result,
		authorizedUpdateCostAccountClassificationCommandV1: result.authorized,
		updateCostAccountClassificationCommandV1: result.command,
		completedUpdateCostAccountClassificationCommandV1: result.completed,
		errorUpdateCostAccountClassificationCommandV1: result.error,
		invokeUpdateCostAccountClassificationCommandV1: result.invoke,
		invokingUpdateCostAccountClassificationCommandV1: result.invoking,
		succeedUpdateCostAccountClassificationCommandV1: result.succeed,
		validationErrorsUpdateCostAccountClassificationCommandV1: result.validationErrors,
		onSucceedUpdateCostAccountClassificationCommandV1: result.onSucceed,
	}
}

export function useUpdateCostAccountCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	name?: string | Ref<string> | (() => string), 
	description?: string | Ref<string> | (() => string), 
	subtotalId?: string | Ref<string> | (() => string), 
	classification?: any | Ref<any> | (() => any), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _name = isRef<string>(name) ? name : ref<string>((typeof name === 'function') ? name() : name)
	const _description = isRef<string>(description) ? description : ref<string>((typeof description === 'function') ? description() : description)
	const _subtotalId = isRef<string>(subtotalId) ? subtotalId : ref<string>((typeof subtotalId === 'function') ? subtotalId() : subtotalId)
	const _classification = isRef<any>(classification) ? classification : ref<any>((typeof classification === 'function') ? classification() : classification)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		name: _name,
		description: _description,
		subtotalId: _subtotalId,
		classification: _classification,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof name === 'function') { _name.value = name() }
			if (typeof description === 'function') { _description.value = description() }
			if (typeof subtotalId === 'function') { _subtotalId.value = subtotalId() }
			if (typeof classification === 'function') { _classification.value = classification() }

			return new c.UpdateCostAccountCommandV1(_workspaceId.value, _strategyId.value, _id.value, _name.value, _description.value, _subtotalId.value, _classification.value)
		})
	}

	return {
		...result,
		authorizedUpdateCostAccountCommandV1: result.authorized,
		updateCostAccountCommandV1: result.command,
		completedUpdateCostAccountCommandV1: result.completed,
		errorUpdateCostAccountCommandV1: result.error,
		invokeUpdateCostAccountCommandV1: result.invoke,
		invokingUpdateCostAccountCommandV1: result.invoking,
		succeedUpdateCostAccountCommandV1: result.succeed,
		validationErrorsUpdateCostAccountCommandV1: result.validationErrors,
		onSucceedUpdateCostAccountCommandV1: result.onSucceed,
	}
}

export function useUpdateCostAccountParentCommandV1(
	workspaceId?: number | Ref<number> | (() => number), 
	strategyId?: string | Ref<string> | (() => string), 
	id?: string | Ref<string> | (() => string), 
	subtotalId?: string | Ref<string> | (() => string), 
) 
{
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>((typeof workspaceId === 'function') ? workspaceId() : workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>((typeof strategyId === 'function') ? strategyId() : strategyId)
	const _id = isRef<string>(id) ? id : ref<string>((typeof id === 'function') ? id() : id)
	const _subtotalId = isRef<string>(subtotalId) ? subtotalId : ref<string>((typeof subtotalId === 'function') ? subtotalId() : subtotalId)

	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		id: _id,
		subtotalId: _subtotalId,

		...useCommand(() => {
			if (typeof workspaceId === 'function') { _workspaceId.value = workspaceId() }
			if (typeof strategyId === 'function') { _strategyId.value = strategyId() }
			if (typeof id === 'function') { _id.value = id() }
			if (typeof subtotalId === 'function') { _subtotalId.value = subtotalId() }

			return new c.UpdateCostAccountParentCommandV1(_workspaceId.value, _strategyId.value, _id.value, _subtotalId.value)
		})
	}

	return {
		...result,
		authorizedUpdateCostAccountParentCommandV1: result.authorized,
		updateCostAccountParentCommandV1: result.command,
		completedUpdateCostAccountParentCommandV1: result.completed,
		errorUpdateCostAccountParentCommandV1: result.error,
		invokeUpdateCostAccountParentCommandV1: result.invoke,
		invokingUpdateCostAccountParentCommandV1: result.invoking,
		succeedUpdateCostAccountParentCommandV1: result.succeed,
		validationErrorsUpdateCostAccountParentCommandV1: result.validationErrors,
		onSucceedUpdateCostAccountParentCommandV1: result.onSucceed,
	}
}

